module.exports = __webpack_public_path__ + "img/please-wait.39c919ea.gif";